import React from "react";


export default function ProjectStatus_PopoverMore(props:any) {

    const onEditWorkflow = () => {
        gd.goTo('p/{0}/info/settings/workflow'.f(props.model.id))
    }

    return (
        <div className="help">
            <div className="ui5-link-small" onClick={onEditWorkflow}>Edit workflow</div>
        </div>
    )
}
